"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Do you accept Medi-Cal and other insurance plans?",
  answer: "Yes, we accept a wide range of insurance providers, including Medi-Cal and most major PPO plans. Our administrative team will help you verify your benefits and maximize your coverage before any procedure begins."
}, {
  question: "What financing options are available for implants and dentures?",
  answer: "We believe everyone deserves a beautiful smile. We offer flexible financing through CareCredit and Proceed Finance, featuring low monthly payment plans and competitive rates to ensure our high-quality dental care fits your budget."
}, {
  question: "How long does the process for custom dentures typically take?",
  answer: "Our El Monte clinic is known for efficiency. While timelines vary based on individual needs, we specialize in streamlined processes that often allow for same-day extractions and faster turnaround times for high-quality custom dentures."
}, {
  question: "Do you offer sedation for extractions and implant surgery?",
  answer: "Your comfort is our priority. We specialize in sedation dentistry, offering various levels of sedation—from light nitrous oxide to deeper options—to ensure a completely relaxed and pain-free experience during your dental procedures."
}];
export default function CommonInquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="125457" id="frequently-asked-questions" className="dark bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div ref={ref} className={`flex flex-col items-center text-center space-y-4 mb-12 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg">
            Find answers to common questions about our insurance policies, flexible financing plans, and specialized dental services in El Monte.
          </p>
        </div>

        <div className={`transition-all duration-700 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border border-border rounded-lg px-6 data-[state=open]:bg-muted/50 data-[state=open]:border-primary/20 transition-colors duration-300 shadow-sm">
                <AccordionTrigger className="text-base md:text-lg font-semibold text-foreground hover:no-underline hover:text-primary py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}